import { fetchStoryGroups } from "../lib/api";
import { COUNTRIES } from "../lib/constants";
import { getCountryIdFromSlug } from "../lib/countries";

export default store => {
  store.on("@init", () => ({
    deepdives: {
      data: {
        all: []
      },
      error: null,
      pending: false,
      fetched: false
    },
    deepdiveCounts: {
      data: {},
      error: null,
      fetched: false,
      pending: false
    }
  }));

  store.on("deepdives/fetch", fetch);

  store.on("deepdives/save", (_, deepdives = {}) => {
    return { deepdives };
  });

  store.on("deepdives/pending", data => {
    return {
      deepdives: {
        pending: true,
        error: null,
        data
      }
    };
  });

  async function fetch({ deepdives }, limit = 20, offset = 0, countryId = "") {
    const { data = {} } = deepdives,
      target = countryId || "all";
    if (data[target].length) return;
    store.dispatch("deepdives/pending");
    const [error, results = []] = await fetchDeepDives(
      countryId,
      limit,
      offset
    );
    store.dispatch("deepdives/save", {
      data: { ...data, [target]: results },
      error,
      pending: false,
      fetched: true
    });
  }

  store.on("deepdives/counts/fetch", async ({ deepdiveCounts = {} }) => {
    const { data = [], fetched = false, pending = false } = deepdiveCounts;
    if (fetched || pending) return;
    store.dispatch("deepdives/counts/pending");
    const [error, results = []] = await fetchStoryGroups({
      types: ["deepdive"],
      limit: 200,
      tags: [],
      fields: ["tag"]
    });
    store.dispatch("deepdives/counts/save", {
      data: results.reduce(reduceCountsResults, data),
      error,
      fetched: true,
      pending: false
    });
  });

  store.on("deepdives/counts/pending", ({ deepdiveCounts }) => {
    return {
      deepdiveCounts: {
        ...deepdiveCounts,
        pending: true,
        error: null
      }
    };
  });

  store.on("deepdives/counts/save", (_, deepdiveCounts) => {
    return { deepdiveCounts };
  });
};

/**
 * Fetch deep dives
 * @param {string} countryId
 * @param {number} limit
 * @param {number} offset
 * @return {[error|null, []Entry|null]}
 */
async function fetchDeepDives(countryId = "", limit = 20, offset = 0) {
  return await fetchStoryGroups({
    types: ["deepdive"],
    limit,
    offset,
    tags: countryId ? [`country-${COUNTRIES[countryId].slug}-published`] : []
  });
}

function reduceCountsResults(acc, { tag = [] }) {
  tag
    .filter(tagWord => tagWord.match(/-published$/))
    .map(tagWord => {
      const slug = tagWord.split("-published")[0];
      return getCountryIdFromSlug(slug);
    })
    .forEach(countryId => {
      acc[countryId] = acc[countryId] ? ++acc[countryId] : 1;
    });

  return acc;
}
